import React from 'react';
const PauseSVG = ({ color = 'white', className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="10"
      viewBox="0 0 8 10"
      fill="none"
    >
      <path
        d="M0.961538 0C0.430758 0 0 0.430758 0 0.961539V8.65385C0 9.18463 0.430758 9.61539 0.961538 9.61539C1.49232 9.61539 1.92308 9.18463 1.92308 8.65385V0.961539C1.92308 0.430758 1.49232 0 0.961538 0Z"
        fill="currentColor"
      />
      <path
        d="M6.08996 0C5.55918 0 5.12842 0.430758 5.12842 0.961539V8.65385C5.12842 9.18463 5.55918 9.61539 6.08996 9.61539C6.62074 9.61539 7.05149 9.18463 7.05149 8.65385V0.961539C7.05149 0.430758 6.62074 0 6.08996 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PauseSVG;
